import { type JSX, type ParentComponent, Show } from "solid-js";

type ICardContainerProps = {
  title?: string | JSX.Element;
  show?: boolean;
  options?: JSX.Element | JSX.Element[];
} & Omit<JSX.HTMLAttributes<HTMLDivElement>, "title">;

const CardContainer: ParentComponent<ICardContainerProps> = (props) => {
  const { class: className, title, show, options, ...rest } = props;

  const showCard = () => {
    if (show === undefined) {
      return true;
    }
    return show;
  };

  return (
    <Show when={showCard()}>
      <div
        class={`space-y-4 rounded-md border bg-white ${className}`}
        {...rest}
      >
        <Show when={title || options}>
          <div class="flex items-center justify-between">
            <Show when={title}>
              <div class="w-full text-lg text-primary-700">{title}</div>
            </Show>
            <Show when={options}>
              <div class="flex items-center justify-end text-sm">{options}</div>
            </Show>
          </div>
        </Show>
        {props.children}
      </div>
    </Show>
  );
};

export default CardContainer;
